import React from 'react';
import '../template-file-css/document-file-template.css';


export const SSS_MentalHealthAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='SSS_MentalHealthAdult' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center>
                        <h3>
                            SIMS SOCIAL SERVICES
                            <br />
                            MENTAL HEALTH ASSESSMENT - ADULT
                        </h3>

                    </center>
                </p>
                <p className='w-750'>
                    <input type='radio' id='rbGender_11_Yes' name='rbGender_11' className='add-only' value='1' /> &nbsp;INITIAL ASSESSMENT

                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbGender_11_No' name='rbGender_11' className='add-only' value='0' />&nbsp; REASSESSMENT

                </p>

                <table>
                    {/* <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Client Name:</span>
                            <input type='text' id="txtClientName_11" name="txtClientName_11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid Number:</span>
                            <input type='text' id="txtMedicaidNumber" name="txtMedicaidNumber" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Client DOB:</span>
                            <input type='date' id="txtClientDob11" name="txtClientDob11" className='add-only' />
                        </td>
                    </tr> */}
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Current Age:</span>
                            <input type='text' id="txtCurrentAge" name="txtCurrentAge" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number:</span>
                            <input type='text' id="txtPhoneNumber_11" name="txtPhoneNumber_11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Primary Language:</span>
                            <input type='text' id="txtPrimaryLanguage" name="txtPrimaryLanguage" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Race/Ethnicity:</span>
                            <input type='text' id="txtRace" name="txtRace" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span>
                            <input type='radio' id='rbGender_1_Yes' name='rbGender_1' className='add-only' value='1' /> Male &nbsp;
                            <input type='radio' id='rbGender_1_No' name='rbGender_1' className='add-only' value='0' /> Female
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Gender Orientation:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbOrientation_Yes' name='rbOrientation' className='add-only' value='1' /> Straight
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbOrientation_No' name='rbOrientation' className='add-only' value='0' /> Lesbian
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbOrientation_Ye' name='rbOrientation' className='add-only' value='2' /> Gay
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbOrientation_Ys' name='rbOrientation' className='add-only' value='3' /> Homosexual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Gender Expression/Identity:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbOrientation_1_Yes' name='rbOrientation_1' className='add-only' value='1' /> Male
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbOrientation_1_No' name='rbOrientation_1' className='add-only' value='0' /> Female
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbOrientation_1_Ye' name='rbOrientation_1' className='add-only' value='2' /> Transgender
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbOrientation_1_Ys' name='rbOrientation_1' className='add-only' value='3' /> Homosexual
                        </td>
                    </tr>
                </table>
                <h3>
                    MHR PROGRAM
                </h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Admission:</span>
                            <input type='date' id="txtDateAdmission" name="txtDateAdmission" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Re/Assessment Date:</span>
                            <input type='date' id="txtAssessmentDate" name="txtAssessmentDate" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>LMHP:</span>
                            <input type='text' id="txtLmhp" name="txtLmhp" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    BEHAVIORAL HEALTH HISTORY - in recipient's own words
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>PRESENTING PROBLEM/ HISTORY of PRESENT ILLNESS</span>
                    <textarea id='txtPresentingProblem_11' name='txtPresentingProblem_11' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>1. CLIENT'S REASON for SEEKING SERVICES</span>
                    <textarea id='txtPresentingProblem_1' name='txtPresentingProblem_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2. PRECIPITATING FACTORS</span>
                    <textarea id='txtPresentingProblem_2' name='txtPresentingProblem_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3. MAJOR SYMPTOMS/DIFFICULTIES</span>
                    <textarea id='txtPresentingProblem_3' name='txtPresentingProblem_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4. BEHAVIORAL and FUNCTIONING IMPACTS</span>
                    <textarea id='txtPresentingProblem_4' name='txtPresentingProblem_4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>5. ONSET/FREQUENCY/COURSE of ISSUES</span>
                    <textarea id='txtPresentingProblem_5' name='txtPresentingProblem_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>6. SERVICES SOUGHT</span>
                    <textarea id='txtPresentingProblem_6' name='txtPresentingProblem_6' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>7. CLIENT EXPECTATION</span>
                    <textarea id='txtPresentingProblem_7' name='txtPresentingProblem_7' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Behavioral Health Provider</span>
                            <input type='text' id="txtCurrentBehavioral" name="txtCurrentBehavioral" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type='text' id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>PAST PSYCHIATRIC HISTORY</span>
                    <span className='small'>(First onset of illness, past diagnostic and treatment history, medications, hospitalizations)</span>
                    <textarea id='txtFirstOnset' name='txtFirstOnset' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Prior Outpatient Mental Health Treatment:</span>
                    <input type='radio' id='rbOutpatient_Yes' name='rbOutpatient' className='add-only' value='1' /> NO &nbsp;
                    <input type='radio' id='rbOutpatient_No' name='rbOutpatient' className='add-only' value='0' /> YES
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Detail:</span>
                    <textarea id='txtDetail' name='txtDetail' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Psychiatric Hospitalization:</span>
                    <input type='radio' id='rbOutpatient_1_Yes' name='rbOutpatient_1' className='add-only' value='1' /> NO &nbsp;
                    <input type='radio' id='rbOutpatient_1_No' name='rbOutpatient_1' className='add-only' value='0' /> YES
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Detail:</span>
                    <textarea id='txtDetail_1' name='txtDetail_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional History/Comments:</span>
                    <textarea id='txtDetail_2' name='txtDetail_2' className='add-only'></textarea>
                </p>
                <h3>
                    SUBSTANCE ABUSE/DEPENDENCE<span className='small'>(Past use of primary, secondary & tertiary current substance, incl. type, frequency, method & age of 1st use)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Check all that apply in the past 12 months</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_1' name='cbCurrentMood_1' className='add-only' value='Anger_1' /> Alcohol Use
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_2' name='cbCurrentMood_2' className='add-only' value='Anger_2' /> Illegal Drug Use
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='Anger_3' /> Injected Drug Use
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_4' name='cbCurrentMood_4' className='add-only' value='Anger_4' /> Tobacco Product Use
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_5' name='cbCurrentMood_5' className='add-only' value='Anger_5' /> Prescription Drug Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_6' name='cbCurrentMood_6' className='add-only' value='Anger_6' /> Non-Prescription (OTC) Abuse
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_7' name='cbCurrentMood_7' className='add-only' value='Anger_7' /> Alcohol and/or Drug Overdose
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_8' name='cbCurrentMood_8' className='add-only' value='Anger_8' /> Alcohol and/or Drug Withdrawal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_9' name='cbCurrentMood_9' className='add-only' value='Anger_9' /> Problems caused by gambling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_10' name='cbCurrentMood_10' className='add-only' value='Anger_10' /> Trouble stopping any substance
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentMood_11' name='cbCurrentMood_11' className='add-only' value='Anger_11' /> Caffeine Use
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCurrentMood_12' name='cbCurrentMood_12' className='add-only' value='Anger_12' /> Other/Describe:&nbsp;
                            <input type='text' id="Substance_11" name="Substance_11" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Abuse Treatment History</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSubstance_1' name='cbSubstance_1' className='add-only' value='Substance_1' /> None
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSubstance_2' name='cbSubstance_2' className='add-only' value='Substance_2' /> Outpatient
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSubstance_3' name='cbSubstance_3' className='add-only' value='Substance_3' />  Intensive Outpatient
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSubstance_4' name='cbSubstance_4' className='add-only' value='Substance_4' /> Residential/Inpatient
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSubstance_5' name='cbSubstance_5' className='add-only' value='Substance_5' /> Detox
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_6' name='cbSubstance_6' className='add-only' value='Substance_6' /> Other:
                            <input type='text' id="Substance_12" name="Substance_12" className='add-only w-250 custom-add-only' />
                        </td>

                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Response to Previous Treatment:</span>
                    <input type='checkbox' id='cbResponse' name='cbResponse' className='add-only' value='Response' />  N/A <br />
                    <textarea id='txtResponse' name='txtResponse' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Relapse History:</span>
                    <input type='checkbox' id='cbResponseHistory' name='cbResponseHistory' className='add-only' value='bResponseHistory' /> N/A <br />
                    <textarea id='txtRelapseHistory' name='txtRelapseHistory' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>SUBSTANCE TYPE</span>
                            <span className='small'>Incl. all use in last 30 days</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AGE of 1ST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtSubstanceUse_1" name="txtSubstanceUse_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAgeOfUse_1" name="txtAgeOfUse_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtYearLife_1" name="txtYearLife_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysInPast_1" name="txtDaysInPast_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysSince_1" name="txtDaysSince_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAmount_1" name="txtAmount_1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_1_Yes' name='rbRoute_1' className='add-only' value='1' /> Oral;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_1_No' name='rbRoute_1' className='add-only' value='0' /> Nasal;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_1_Ye' name='rbRoute_1' className='add-only' value='2' /> Smoking;
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbRoute_1_Ys' name='rbRoute_1' className='add-only' value='3' /> Non-IV Injxn;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_1_Yw' name='rbRoute_1' className='add-only' value='4' /> IV
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>SUBSTANCE TYPE</span>
                            <span className='small'>Incl. all use in last 30 days</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AGE of 1ST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtSubstanceUse_2" name="txtSubstanceUse_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAgeOfUse_2" name="txtAgeOfUse_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtYearLife_2" name="txtYearLife_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysInPast_2" name="txtDaysInPast_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysSince_2" name="txtDaysSince_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAmount_2" name="txtAmount_2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_2_Yes' name='rbRoute_2' className='add-only' value='1' /> Oral;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_2_No' name='rbRoute_2' className='add-only' value='0' /> Nasal;
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbRoute_2_Ye' name='rbRoute_2' className='add-only' value='2' /> Smoking;
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbRoute_2_Ys' name='rbRoute_2' className='add-only' value='3' /> Non-IV Injxn;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_2_Yw' name='rbRoute_2' className='add-only' value='4' /> IV
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>SUBSTANCE TYPE</span>
                            <span className='small'>Incl. all use in last 30 days</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AGE of 1ST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtSubstanceUse_3" name="txtSubstanceUse_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAgeOfUse_3" name="txtAgeOfUse_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtYearLife_3" name="txtYearLife_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysInPast_3" name="txtDaysInPast_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysSince_3" name="txtDaysSince_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAmount_3" name="txtAmount_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_3_Yes' name='rbRoute_3' className='add-only' value='1' /> Oral;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_3_No' name='rbRoute_3' className='add-only' value='0' /> Nasal;
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbRoute_3_Ye' name='rbRoute_3' className='add-only' value='2' /> Smoking;
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbRoute_3_Ys' name='rbRoute_3' className='add-only' value='3' /> Non-IV Injxn;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_3_Yw' name='rbRoute_3' className='add-only' value='4' /> IV
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>SUBSTANCE TYPE</span>
                            <span className='small'>Incl. all use in last 30 days</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AGE of 1ST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtSubstanceUse_4" name="txtSubstanceUse_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAgeOfUse_4" name="txtAgeOfUse_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtYearLife_4" name="txtYearLife_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysInPast_4" name="txtDaysInPast_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysSince_4" name="txtDaysSince_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAmount_4" name="txtAmount_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_4_Yes' name='rbRoute_4' className='add-only' value='1' /> Oral;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_4_No' name='rbRoute_4' className='add-only' value='0' /> Nasal;
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbRoute_4_Ye' name='rbRoute_4' className='add-only' value='2' /> Smoking;
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbRoute_4_Ys' name='rbRoute_4' className='add-only' value='3' /> Non-IV Injxn;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_4_Yw' name='rbRoute_4' className='add-only' value='4' /> IV
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>SUBSTANCE TYPE</span>
                            <span className='small'>Incl. all use in last 30 days</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AGE of 1ST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtSubstanceUse_5" name="txtSubstanceUse_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAgeOfUse_5" name="txtAgeOfUse_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtYearLife_5" name="txtYearLife_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysInPast_5" name="txtDaysInPast_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDaysSince_5" name="txtDaysSince_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtAmount_" name="txtAmount_" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_5_Yes' name='rbRoute_5' className='add-only' value='1' /> Oral;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_5_No' name='rbRoute_5' className='add-only' value='0' /> Nasal;
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbRoute_5_Ye' name='rbRoute_5' className='add-only' value='2' /> Smoking;
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbRoute_5_Ys' name='rbRoute_5' className='add-only' value='3' /> Non-IV Injxn;
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbRoute_5_Yw' name='rbRoute_5' className='add-only' value='4' /> IV
                        </td>
                    </tr>
                </table>
                <h3>
                    PHYSICAL
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>CURRENT MEDICAL CONDITIONS</span>
                            <span className='small'>(Check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbPregnant_1' name='rbPregnant_1' className='add-only' value='Pregnant_1' /> Pregnant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Due Date:</b> <input type='date' id="txtDueDate_11" name="txtDueDate_11" className='add-only w-200 custom-add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Prenatal Care:</b> <input type='text' id="txtPrenatalCare_2" name="txtPrenatalCare_2" className='add-only w-200 custom-add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_2' name='cbPregnant_2' className='add-only' value='Pregnant_2' /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_3' name='cbPregnant_3' className='add-only' value='Pregnant_3' /> Congestive Heart Failure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_4' name='cbPregnant_4' className='add-only' value='Pregnant_4' /> Asthma
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_5' name='cbPregnant_5' className='add-only' value='Pregnant_5' /> Seizure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_6' name='cbPregnant_6' className='add-only' value='Pregnant_6' /> Cancer
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_7' name='cbPregnant_7' className='add-only' value='Pregnant_7' /> Underweight
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_8' name='cbPregnant_8' className='add-only' value='Pregnant_8' /> Stroke
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_9' name='cbPregnant_9' className='add-only' value='Pregnant_9' /> High Blood Pressure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_10' name='cbPregnant_10' className='add-only' value='Pregnant_10' /> Emphysema
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_11' name='cbPregnant_11' className='add-only' value='Pregnant_11' /> Cirrhosis
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_12' name='cbPregnant_12' className='add-only' value='Pregnant_12' /> Chronic Pain
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_13' name='cbPregnant_13' className='add-only' value='Pregnant_13' /> Overweight
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_14' name='cbPregnant_14' className='add-only' value='Pregnant_14' /> Heart Disease
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_15' name='cbPregnant_15' className='add-only' value='Pregnant_15' /> Chronic Pain
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_16' name='cbPregnant_16' className='add-only' value='Pregnant_16' /> Sexually Transmitted Dz.
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_17' name='cbPregnant_17' className='add-only' value='Pregnant_17' /> Epilepsy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_18' name='cbPregnant_18' className='add-only' value='Pregnant_18' /> Digestive Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_19' name='cbPregnant_19' className='add-only' value='Pregnant_19' /> Thyroid Disease
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant_20' name='cbPregnant_20' className='add-only' value='Pregnant_20' /> Diabetes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPregnant_21' name='cbPregnant_21' className='add-only' value='Pregnant_21' /> Other:
                            &nbsp;
                            <input type='text' id="txtPregnant_21Other" name="txtPregnant_21Other" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    CURRENT & PAST MEDICATIONS <span className='small'>(Including non-psychotropic medications)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-100'>
                            <span className='eleHeader'>Medication</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Dose</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Frequency</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Route</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Current</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>COMMENTS </span><span className='small'>(Reason prescribed/response, etc)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='text' id="txtMedication_1" name="txtMedication_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDose_1" name="txtDose_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtFrequency_21" name="txtFrequency_21" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtRoute_1" name="txtRoute_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrent_1_Yes' name='rbCurrent_1' className='add-only' value='1' />&nbsp; Yes; &nbsp;
                            <input type='radio' id='rbCurrent_1_No' name='rbCurrent_1' className='add-only' value='0' />&nbsp; No
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtComments_1" name="txtComments_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='text' id="txtMedication_2" name="txtMedication_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDose_2" name="txtDose_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtFrequency_12" name="txtFrequency_12" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtRoute_2" name="txtRoute_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrent_2_Yes' name='rbCurrent_2' className='add-only' value='1' />&nbsp; Yes; &nbsp;
                            <input type='radio' id='rbCurrent_2_No' name='rbCurrent_2' className='add-only' value='0' />&nbsp; No
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtComments_2" name="txtComments_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='text' id="txtMedication_3" name="txtMedication_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDose_3" name="txtDose_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtFrequency_13" name="txtFrequency_13" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtRoute_3" name="txtRoute_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrent_3_Yes' name='rbCurrent_3' className='add-only' value='1' />&nbsp; Yes; &nbsp;
                            <input type='radio' id='rbCurrent_3_No' name='rbCurrent_3' className='add-only' value='0' />&nbsp; No
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtComments_3" name="txtComments_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='text' id="txtMedication_4" name="txtMedication_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDose_4" name="txtDose_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtFrequency_4" name="txtFrequency_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtRoute_4" name="txtRoute_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrent_4_Yes' name='rbCurrent_4' className='add-only' value='1' />&nbsp; Yes; &nbsp;
                            <input type='radio' id='rbCurrent_4_No' name='rbCurrent_4' className='add-only' value='0' />&nbsp; No
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtComments_4" name="txtComments_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    ALLERGIES
                </h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReported' name='cbReported' className='add-only' value='Reported' /> No Reported Drug or Food Allergy
                        </td>
                        <td className='w-375'>
                            <input type='text' id="txtReported" name="txtReported" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOtherReported' name='cbOtherReported' className='add-only' value='OtherReported' /> Other/Describe:
                        </td>
                        <td className='w-375'>
                            <input type='text' id="txtOtherReported" name="txtOtherReported" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    PRIMARY CARE PHYSICIAN
                </h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id="txtOtherName" name="txtOtherName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id="txtOtherPhone" name="txtOtherPhone" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>ADDITIONAL MEDICAL HISTORY</span>
                    <span className='small'>(Diagnosis, Hospitalization, Surgery, labs values, status of conditions, etc)</span>
                    <textarea id='txtDiagnosis' name='txtDiagnosis' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SOCIAL - CURRENT LEGAL STATUS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbNone_1' name='rbNone_1' className='add-only' value='None_1' /> None
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='rbNone_2' name='rbNone_2' className='add-only' value='None_2' />  Parole
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='rbNone_3' name='rbNone_3' className='add-only' value='None_3' /> Court-Ordered Outpatient Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbNone_4' name='rbNone_4' className='add-only' value='None_4' />  Probation
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='rbNone_5' name='rbNone_5' className='add-only' value='None_5' /> AOT
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='rbNone_6' name='rbNone_6' className='add-only' value='None_6' />  Judicial
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbNone_7' name='rbNone_7' className='add-only' value='None_7' /> Charges Pending
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='rbNone_8' name='rbNone_8' className='add-only' value='None_8' /> Other:
                            &nbsp;
                            <input type='text' id="txtNone_8Other" name="txtNone_8Other" className='add-only w-250 custom-add-only' />

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PAST LEGAL STATUS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLegalPast_1' name='cbLegalPast_1' className='add-only' value='LegalPast_1' /> None
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLegalPast_2' name='cbLegalPast_2' className='add-only' value='LegalPast_2' />  DWI
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLegalPast_3' name='cbLegalPast_3' className='add-only' value='LegalPast_3' /> Prior Arrests
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLegalPast_4' name='cbLegalPast_4' className='add-only' value='LegalPast_4' />  Prior Incarcerations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLegalPast_5' name='cbLegalPast_5' className='add-only' value='LegalPast_5' />  Other:
                            &nbsp;
                            <input type='text' id="txtLegalPast_5Other" name="txtLegalPast_5Other" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    FAMILY HISTORY <span className='small'>(Relationship status with relatives, family involvement in treatment, and living status of significant relatives)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Custodial Status</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCustodial_1' name='cbCustodial_1' className='add-only' value='Custodial_1' /> Independent Adult
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCustodial_2' name='cbCustodial_2' className='add-only' value='Custodial_2' /> Biologic Father
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCustodial_3' name='cbCustodial_3' className='add-only' value='Custodial_3' /> Biologic Mother
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCustodial_4' name='cbCustodial_4' className='add-only' value='Custodial_4' /> Joint Biologic Parents
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCustodial_5' name='cbCustodial_5' className='add-only' value='Custodial_5' /> Gov't/Judicial
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Info:</span>
                            <input type='text' id="txtContactInfo" name="txtContactInfo" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relation</span>
                            <input type='text' id="txtRelation" name="txtRelation" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                            <input type='text' id="txtPhoneRelation" name="txtPhoneRelation" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Adverse Circumstances in Family of Origin</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_1' name='cbAdverse_1' className='add-only' value='Adverse_1' /> N/A
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_2' name='cbAdverse_2' className='add-only' value='Adverse_2' /> Poverty
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_3' name='cbAdverse_3' className='add-only' value='Adverse_3' /> Criminal Behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_4' name='cbAdverse_4' className='add-only' value='Adverse_4' /> Mental Illness
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_5' name='cbAdverse_5' className='add-only' value='Adverse_5' /> Trauma
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_6' name='cbAdverse_6' className='add-only' value='Adverse_6' /> Criminal Behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_7' name='cbAdverse_7' className='add-only' value='Adverse_7' /> Neglect
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_8' name='cbAdverse_8' className='add-only' value='Adverse_8' /> Violence
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_9' name='cbAdverse_9' className='add-only' value='Adverse_9' /> Domestic Violence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_11' name='cbAdverse_11' className='add-only' value='Adverse_11' /> Substance Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdverse_12' name='cbAdverse_12' className='add-only' value='Adverse_12' /> Divorce
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAdverse_13' name='cbAdverse_13' className='add-only' value='Adverse_13' /> Other: &nbsp;
                            <input type='text' id="txtPhoneRelationOther" name="txtPhoneRelationOther" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Family Stress</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_1' name='cbFamilyStress_1' className='add-only' value='FamilyStress_1' /> Low Stress
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_2' name='cbFamilyStress_2' className='add-only' value='FamilyStress_2' /> Mildly Stressed
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_3' name='cbFamilyStress_3' className='add-only' value='FamilyStress_3' /> Moderately Stressful
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_4' name='cbFamilyStress_4' className='add-only' value='FamilyStress_4' /> Highly Stressful
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_5' name='cbFamilyStress_5' className='add-only' value='FamilyStress_5' /> Extremely Stressful
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamilyStress_6' name='cbFamilyStress_6' className='add-only' value='FamilyStress_6' /> Other:&nbsp;
                            <input type='text' id="txtFamilyStress_6" name="txtFamilyStress_6" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Family Supports</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_11' name='cbFamilyStress_11' className='add-only' value='FamilyStress_11' /> Highly Supportive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_12' name='cbFamilyStress_12' className='add-only' value='FamilyStress_12' /> Supportive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_13' name='cbFamilyStress_13' className='add-only' value='FamilyStress_13' /> Limited Support
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_14' name='cbFamilyStress_14' className='add-only' value='FamilyStress_14' /> Minimal Support
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyStress_15' name='cbFamilyStress_15' className='add-only' value='FamilyStress_15' /> No Support
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamilyStress_16' name='cbFamilyStress_16' className='add-only' value='FamilyStress_16' /> Other:
                            &nbsp;
                            <input type='text' id="txtFamilyStress_16" name="txtFamilyStress_16" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>TRAUMA HISTORY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_1' name='cbTrauma_1' className='add-only' value='Trauma_1' /> None
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_2' name='cbTrauma_2' className='add-only' value='Trauma_2' /> Experienced
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_3' name='cbTrauma_3' className='add-only' value='Trauma_3' /> Witnessed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_4' name='cbTrauma_4' className='add-only' value='Trauma_4' /> Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_5' name='cbTrauma_5' className='add-only' value='Trauma_5' /> Neglect
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_6' name='cbTrauma_6' className='add-only' value='Trauma_6' /> Violence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_7' name='cbTrauma_7' className='add-only' value='Trauma_7' /> Sexual Assault
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTrauma_8' name='cbTrauma_8' className='add-only' value='Trauma_8' /> Other:
                            &nbsp;
                            <input type='text' id="txtTrauma_9" name="txtTrauma_9" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    LIVING SITUATION  <span className='small'>(Current status and functioning)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Primary Residence</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_11' name='cbTrauma_11' className='add-only' value='Trauma_11' /> Own Home
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_21' name='cbTrauma_21' className='add-only' value='Trauma_21' /> Apartment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_31' name='cbTrauma_31' className='add-only' value='Trauma_31' /> Relative's Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_41' name='cbTrauma_41' className='add-only' value='Trauma_41' /> Group Home
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_42' name='cbTrauma_42' className='add-only' value='Trauma_42' /> Homeless
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_43' name='cbTrauma_43' className='add-only' value='Trauma_43' /> Living w/ friend
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How long at current residence?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Level of time in community of residence?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id="txtHowLong" name="txtHowLong" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id="txtLevelOf" name="txtLevelOf" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Means of transportation:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Source of meals/food:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id="txtTransportation" name="txtTransportation" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id="txtSource" name="txtSource" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Family/Household Composition:</span>
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id="txtHousehold_11" name="txtHousehold_11" className='add-only' />
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txtAdditionalComments_2' name='txtAdditionalComments_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs - List what is needed to improve/maintain daily living situation-</span>
                    <textarea id='txtNeeds_11' name='txtNeeds_11' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences - Include things recipient feels will enhance his/her living situation-</span>
                    <textarea id='txtPreferences_11' name='txtPreferences_11' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths - List assets, service options and resources the person has to meet needs, including housing options-</span>
                    <textarea id='txtStrengths_11' name='txtStrengths_11' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities/Interests - Include recipients reported skills, aptitudes, capabilities, talents & competencies that might assist in maintaining or improving living situation</span>
                    <textarea id='txtAbilities_11' name='txtAbilities_11' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>
                        LEARNING/WORKING and FUNCTIONAL STATUS - EMPLOYMENT/EDUCATION/REHABILITATION STATUS
                    </h3>

                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Source of Income:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Estimated Monthly Income:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id="txtCurrentSource" name="txtCurrentSource" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id="txtEstimatedMonthly" name="txtEstimatedMonthly" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Employment Status:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Prior Employment Status</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id="txtCurrentEmploymentStatus" name="txtCurrentEmploymentStatus" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id="txtPriorEmployment" name="txtPriorEmployment" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Highest Grade Completed or Degree:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Military Status:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id="txtHighestGradeCompleted" name="txtHighestGradeCompleted" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMilitary_1' name='cbMilitary_1' className='add-only' value='Military' /> N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Difficulties with reading/writing:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Estimated Literacy Level:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbDifficulties_Yes' name='rbDifficulties' className='add-only' value='1' /> &nbsp;NO; &nbsp;
                            <input type='radio' id='rbDifficulties_No' name='rbDifficulties' className='add-only' value='0' />&nbsp; YES &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type='text' id="txtEstimatedLiteracyLevel" name="txtEstimatedLiteracyLevel" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Assistive Devices utilized/required:</span>
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbDifficulties_1_Yes' name='rbDifficulties_1' className='add-only' value='1' /> &nbsp;NO; &nbsp;
                            <input type='radio' id='rbDifficulties_1_No' name='rbDifficulties_1' className='add-only' value='0' />&nbsp; YES &nbsp;
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txtAbilitiesAdditional' name='txtAbilitiesAdditional' className='add-only'></textarea>
                </p>
                <h3>
                    CURRENT STATUS and FUNCTIONING-
                    <span className='small'>Assess ability to fulfill responsibilities, interact w/ others, capacity self-care, missed activities, work/school due to health, etc</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Functional Status Impairment Rating</span>
                            <span className='small'>(from LOCUS Functional Status Evaluation Parameters)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_1_Yes' name='rbFunctional_1' className='add-only' value='1' /> Minimal
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_1_No' name='rbFunctional_1' className='add-only' value='0' /> Mild
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_1_Ye' name='rbFunctional_1' className='add-only' value='2' /> Moderate
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_1_Ys' name='rbFunctional_1' className='add-only' value='3' /> Serious
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_1_Yw' name='rbFunctional_1' className='add-only' value='4' /> Extreme
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbFunctional_1_Yey' name='rbFunctional_1' className='add-only' value='5' /> Other:
                            <input type='text' id="txtEstimatedFunctional_11" name="txtEstimatedFunctional_11" className='add-only  w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>As Evidenced By:</span>
                    <textarea id='txtEvidenced' name='txtEvidenced' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs-</span>
                    <span className='small'>List what is needed to improve/maintain income, employment, education, vocational skills, etc.</span>
                    <textarea id='txtEvidencedNeeds' name='txtEvidencedNeeds' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Problems w/ Basic Needs</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_2_Yes' name='rbFunctional_2' className='add-only' value='1' /> Food
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_2_No' name='rbFunctional_2' className='add-only' value='0' /> Shelter
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_2_Ye' name='rbFunctional_2' className='add-only' value='2' /> Clothing
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_2_Ys' name='rbFunctional_2' className='add-only' value='3' /> Funds
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_2_Yw' name='rbFunctional_2' className='add-only' value='4' /> Healthcare
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbFunctional_1_Yei' name='rbFunctional_1' className='add-only' value='5' /> ADL's
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbFunctional_1_Yeu' name='rbFunctional_1' className='add-only' value='6' /> Other:
                            &nbsp;
                            <input type='text' id="txtEstimatedFunctional_12" name="txtEstimatedFunctional_12" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences-</span>
                    <span className='small'>Include things recipient feels will enhance functional status with regard to income, employment, learning, literacy, etc.</span>
                    <textarea id='txtEvidencedPreferences' name='txtEvidencedPreferences' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths-</span>
                    <span className='small'>List assets, service options, skills & resources recipient has to meet needs.</span>
                    <textarea id='txtEvidencedStrengths' name='txtEvidencedStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities/Interests-</span>
                    <span className='small'>Include recipients reported skills, aptitudes, capabilities, talents & competencies that might assist in maintaining or improving functional status.</span>
                    <textarea id='txtEvidencedAbilities' name='txtEvidencedAbilities' className='add-only'></textarea>
                </p>
                <h3>
                    SOCIAL HISTORY and COMMUNITY INTEGRATION
                </h3>
                <h3>
                    Current status and functioning<span className='small'>(Involvement in the community, social supports and activities, social barriers)</span>
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Does recipient feel supported by friends or family?</span>
                    <input type='radio' id='rbFamily_1_Yes' name='rbFamily_1' className='add-only' value='1' /> &nbsp;YES ; &nbsp;
                    <input type='radio' id='rbFamily_1_No' name='rbFamily_1' className='add-only' value='0' />&nbsp; NO
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Recreational Activities:</span>
                    <textarea id='txtRecreationalActivities' name='txtRecreationalActivities' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Self-Help Activities:</span>
                    <textarea id='txtSelfHelp' name='txtSelfHelp' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txtRecreationalActivitiesAdditional' name='txtRecreationalActivitiesAdditional' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs-</span>
                    <span className='small'>List what is needed to improve/maintain recreation, social functioning & community integration.</span>
                    <textarea id='txtEvidencedAbNeeds' name='txtEvidencedAbNeeds' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences-</span>
                    <span className='small'>Include things recipient feels will enhance or stimulate recreational interests, social functioning & community integration.</span>
                    <textarea id='txtEvidencedAbPreferences' name='txtEvidencedAbPreferences' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths-</span>
                    <span className='small'>List assets, service options & skills that may enhance socialization & community integration..</span>
                    <textarea id='txtEvidencedAbStrengths' name='txtEvidencedAbStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities/Interests-</span>
                    <span className='small'>Include recipient reported skills, aptitudes, talents & competencies that may help maintain or improve socialization & community functioning.</span>
                    <textarea id='txtEvidencedAbInterests' name='txtEvidencedAbInterests' className='add-only'></textarea>
                </p>
                <h3>
                    MENTAL STAUS EXAMINATION <span className='small'>(Check all that apply)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ORIENTATION/SENSORIUM/COGNITION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1' name='cbOrientation_1' className='add-only' value='Orientation_1' /> Alert
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2' name='cbOrientation_2' className='add-only' value='Orientation_2' />  Lethargic
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_3' name='cbOrientation_3' className='add-only' value='Orientation_3' /> Somnolent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4' name='cbOrientation_4' className='add-only' value='Orientation_4' />  Stuporous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Oriented to:</b>

                            <input type='text' id="txtOrientation_5" name="txtOrientation_5" className='add-only  w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5' name='cbOrientation_5' className='add-only' value='Orientation_5' /> Person
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6' name='cbOrientation_6' className='add-only' value='Orientation_6' />  Place
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7' name='cbOrientation_7' className='add-only' value='Orientation_7' /> Time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8' name='cbOrientation_8' className='add-only' value='Orientation_8' /> Situation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9' name='cbOrientation_9' className='add-only' value='Orientation_9' />  Normal Concentration
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10' name='cbOrientation_10' className='add-only' value='Orientation_10' /> Impaired Concentration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientation_11' name='cbOrientation_8' className='add-only' value='Orientation_11' /> Other:
                            &nbsp;
                            <input type='text' id="txtOrientation_8" name="txtOrientation_8" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>GENERAL APPERANCE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_111_1' name='cbOrientation_111_1' className='add-only' value='Orientation_1_1' /> Healthy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_111_2' name='cbOrientation_111_2' className='add-only' value='Orientation_1_2' />  Overweight
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_111_3' name='cbOrientation_111_3' className='add-only' value='Orientation_1_3' /> Thin
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_111_4' name='cbOrientation_111_4' className='add-only' value='Orientation_1_4' />  Obese
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1_12' name='cbOrientation_1_12' className='add-only' value='Orientation_1_12' />  Unkempt
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1_13' name='cbOrientation_1_13' className='add-only' value='Orientation_1_13' />  As Stated Age
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1_5' name='cbOrientation_1_5' className='add-only' value='Orientation_1_5' /> Older Than Stated Age
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1_6' name='cbOrientation_1_6' className='add-only' value='Orientation_1_6' />  Young-looking
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1_7' name='cbOrientation_1_7' className='add-only' value='Orientation_1_7' /> Emaciated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1_8' name='cbOrientation_1_8' className='add-only' value='Orientation_1_8' /> Tattoos
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1_9' name='cbOrientation_1_9' className='add-only' value='Orientation_1_9' />  Malodorous
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1_10' name='cbOrientation_1_10' className='add-only' value='Orientation_1_10' /> Poor-Hygiene
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1_11' name='cbOrientation_1_11' className='add-only' value='Orientation_1_11' /> Disheveled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientation_1_14' name='cbOrientation_1_14' className='add-only' value='Orientation_1_14' /> Other:
                            &nbsp;
                            <input type='text' id="txtOrientation_14" name="txtOrientation_14" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>BEHAVIOR & PSYCHOMOTOR ACTIVITY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2_1' name='cbOrientation_2_1' className='add-only' value='Orientation_2_1' /> Normal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2_2' name='cbOrientation_2_2' className='add-only' value='Orientation_2_2' />  Overactive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2_3' name='cbOrientation_2_3' className='add-only' value='Orientation_2_3' /> Hypoactive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2_4' name='cbOrientation_2_4' className='add-only' value='Orientation_2_4' />  Catatonia
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2_12' name='cbOrientation_2_12' className='add-only' value='Orientation_2_12' />  Abnormal Gait
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2_13' name='cbOrientation_2_13' className='add-only' value='Orientation_2_13' />  Combative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2_5' name='cbOrientation_2_5' className='add-only' value='Orientation_2_5' /> Tics
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2_6' name='cbOrientation_2_6' className='add-only' value='Orientation_2_6' />  Tremor
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientation_2_11' name='cbOrientation_2_11' className='add-only' value='Orientation_2_11' /> Other:
                            &nbsp;
                            <input type='text' id="txtOrientation_2_8" name="txtOrientation_2_8" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>DRESS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_3_1' name='cbOrientation_3_1' className='add-only' value='Orientation_3_1' /> Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_3_2' name='cbOrientation_3_2' className='add-only' value='Orientation_3_2' />  Eccentric/Bizarre
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_3_3' name='cbOrientation_3_3' className='add-only' value='Orientation_3_3' /> Seductive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_3_4' name='cbOrientation_3_4' className='add-only' value='Orientation_3_4' />  Meticulous
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_3_12' name='cbOrientation_3_12' className='add-only' value='Orientation_3_12' />  Not Assessed
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MOTOR ACTIVITY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4_1' name='cbOrientation_4_1' className='add-only' value='Orientation_4_1' /> Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4_2' name='cbOrientation_4_2' className='add-only' value='Orientation_4_2' />  Agitation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4_3' name='cbOrientation_4_3' className='add-only' value='Orientation_4_3' /> Retardation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4_4' name='cbOrientation_4_4' className='add-only' value='Orientation_4_4' />  Repetitive Actions
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4_12' name='cbOrientation_4_12' className='add-only' value='Orientation_4_12' />  Posturing
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4_13' name='cbOrientation_4_13' className='add-only' value='Orientation_4_13' />  Tics
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4_5' name='cbOrientation_4_5' className='add-only' value='Orientation_4_5' /> Tremor
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4_6' name='cbOrientation_4_6' className='add-only' value='Orientation_4_6' />  Unusual Gait
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4_7' name='cbOrientation_4_7' className='add-only' value='Orientation_4_7' /> Not Assessed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ATTITUDE/INTERVIEW BEHAVIOR</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_1' name='cbOrientation_5_1' className='add-only' value='Orientation_5_1' /> Optimal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_2' name='cbOrientation_5_2' className='add-only' value='Orientation_5_2' />  Constructive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_3' name='cbOrientation_5_3' className='add-only' value='Orientation_5_3' /> Motivated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_4' name='cbOrientation_5_4' className='add-only' value='Orientation_5_4' />  Obstructive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_12' name='cbOrientation_5_12' className='add-only' value='Orientation_5_12' />  Adversarial
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_13' name='cbOrientation_5_13' className='add-only' value='Orientation_5_13' />  Inaccessible
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_5' name='cbOrientation_5_5' className='add-only' value='Orientation_5_5' /> Cooperative
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_6' name='cbOrientation_5_6' className='add-only' value='Orientation_5_6' />  Uncooperative
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_7' name='cbOrientation_5_7' className='add-only' value='Orientation_5_7' /> Defensive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_8' name='cbOrientation_5_8' className='add-only' value='Orientation_5_8' /> Hostile
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_9' name='cbOrientation_5_9' className='add-only' value='Orientation_5_9' />  Guarded
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_10' name='cbOrientation_5_10' className='add-only' value='Orientation_5_10' /> Apathetic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_14' name='cbOrientation_5_14' className='add-only' value='Orientation_5_14' /> Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_15' name='cbOrientation_5_15' className='add-only' value='Orientation_5_15' />  Aggressive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_16' name='cbOrientation_5_16' className='add-only' value='Orientation_5_16' /> Argumentative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_17' name='cbOrientation_5_17' className='add-only' value='Orientation_5_17' /> Child-like
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_18' name='cbOrientation_5_18' className='add-only' value='Orientation_5_18' />  Evasive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_19' name='cbOrientation_5_19' className='add-only' value='Orientation_5_19' /> Angry
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_20' name='cbOrientation_5_20' className='add-only' value='Orientation_5_20' /> Seductive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_21' name='cbOrientation_5_21' className='add-only' value='Orientation_5_21' />  Demanding
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_22' name='cbOrientation_5_22' className='add-only' value='Orientation_5_22' /> Drastic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_23' name='cbOrientation_5_23' className='add-only' value='Orientation_5_23' /> Irritable
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_24' name='cbOrientation_5_24' className='add-only' value='Orientation_5_24' />  Manipulative
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_5_25' name='cbOrientation_5_25' className='add-only' value='Orientation_5_25' /> Passive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SPEECH</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_1' name='cbOrientation_6_1' className='add-only' value='Orientation_6_1' /> Normal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_2' name='cbOrientation_6_2' className='add-only' value='Orientation_6_2' />  Spontaneous
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_3' name='cbOrientation_6_3' className='add-only' value='Orientation_6_3' /> Impoverished
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_4' name='cbOrientation_6_4' className='add-only' value='Orientation_6_4' />  Soft
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_12' name='cbOrientation_6_12' className='add-only' value='Orientation_6_12' />  Whispered
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_13' name='cbOrientation_6_13' className='add-only' value='Orientation_6_13' />  Hesitant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_5' name='cbOrientation_6_5' className='add-only' value='Orientation_6_5' /> Slowed
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_6' name='cbOrientation_6_6' className='add-only' value='Orientation_6_6' />  Mumbled
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_7' name='cbOrientation_6_7' className='add-only' value='Orientation_6_7' /> Pressured
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_8' name='cbOrientation_6_8' className='add-only' value='Orientation_6_8' /> Impediment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_9' name='cbOrientation_6_9' className='add-only' value='Orientation_6_9' />  Stuttering
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_10' name='cbOrientation_6_10' className='add-only' value='Orientation_6_10' /> Verbose
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_20' name='cbOrientation_6_20' className='add-only' value='Orientation_6_20' /> Monotonous
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_21' name='cbOrientation_6_21' className='add-only' value='Orientation_6_21' />  Slow
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_22' name='cbOrientation_6_22' className='add-only' value='Orientation_6_22' /> Rapid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_23' name='cbOrientation_6_23' className='add-only' value='Orientation_6_23' /> Loud
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_6_24' name='cbOrientation_6_24' className='add-only' value='Orientation_6_24' />  Mute
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MOOD</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_1' name='cbOrientation_7_1' className='add-only' value='Orientation_7_1' /> Dysphoric
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_2' name='cbOrientation_7_2' className='add-only' value='Orientation_7_2' />  Euthymic
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_3' name='cbOrientation_7_3' className='add-only' value='Orientation_7_3' /> Expansive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_4' name='cbOrientation_7_4' className='add-only' value='Orientation_7_4' />  Irritable
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_12' name='cbOrientation_7_12' className='add-only' value='Orientation_7_12' />  Labile
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_13' name='cbOrientation_7_13' className='add-only' value='Orientation_7_13' />  Elevated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_5' name='cbOrientation_7_5' className='add-only' value='Orientation_7_5' /> Euphoric
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_6' name='cbOrientation_7_6' className='add-only' value='Orientation_7_6' />  Ecstatic
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_7' name='cbOrientation_7_7' className='add-only' value='Orientation_7_7' /> Depressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_8' name='cbOrientation_7_8' className='add-only' value='Orientation_7_8' /> Grief/Mourning
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_9' name='cbOrientation_7_9' className='add-only' value='Orientation_7_9' />  Alexithymic
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_10' name='cbOrientation_7_10' className='add-only' value='Orientation_7_10' /> Elated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_20' name='cbOrientation_7_20' className='add-only' value='Orientation_7_20' /> Hypomanic
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_21' name='cbOrientation_7_21' className='add-only' value='Orientation_7_21' />  Manic
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_22' name='cbOrientation_7_22' className='add-only' value='Orientation_7_22' /> Anxious
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_23' name='cbOrientation_7_23' className='add-only' value='Orientation_7_23' /> Tense
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_7_24' name='cbOrientation_7_24' className='add-only' value='Orientation_7_24' />  Grandiose
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientation_7_26' name='cbOrientation_7_26' className='add-only' value='Orientation_7_26' /> Other:
                            &nbsp;
                            <input type='text' id='txtOrientation_7_26' name='txtOrientation_7_26' className='add-only  w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>AFFECT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_1' name='cbOrientation_8_1' className='add-only' value='Orientation_8_1' /> Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_2' name='cbOrientation_8_2' className='add-only' value='Orientation_8_2' />  Inappropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_3' name='cbOrientation_8_3' className='add-only' value='Orientation_8_3' /> Blunted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_4' name='cbOrientation_8_4' className='add-only' value='Orientation_8_4' />  Restricted
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_12' name='cbOrientation_8_12' className='add-only' value='Orientation_8_12' />  Flat
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_13' name='cbOrientation_8_13' className='add-only' value='Orientation_8_13' />  Labile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientatiion_8_5' name='cbOrientatiion_8_5' className='add-only' value='Orientation_8_5' /> Tearful
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_6' name='cbOrientation_8_6' className='add-only' value='Orientation_8_6' />  Intense
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_7' name='cbOrientation_8_7' className='add-only' value='Orientation_8_7' /> Congruent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_8' name='cbOrientation_8_8' className='add-only' value='Orientation_8_8' /> Incongruent
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_9' name='cbOrientation_8_9' className='add-only' value='Orientation_8_9' />  Reactive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_8_10' name='cbOrientation_8_10' className='add-only' value='Orientation_8_10' /> Constricted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>INSIGHT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9_1' name='cbOrientation_9_1' className='add-only' value='Orientation_9_1' /> Excellent
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9_2' name='cbOrientation_9_2' className='add-only' value='Orientation_9_2' />  Good
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9_3' name='cbOrientation_9_3' className='add-only' value='Orientation_9_3' /> Fair
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9_4' name='cbOrientation_9_4' className='add-only' value='Orientation_9_4' />  Poor
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9_12' name='cbOrientation_9_12' className='add-only' value='Orientation_9_12' />  Nil
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9_13' name='cbOrientation_9_13' className='add-only' value='Orientation_9_13' />  Denial
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9_5' name='cbOrientation_9_5' className='add-only' value='Orientation_9_5' /> True Emotional Insight
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9_6' name='cbOrientation_9_6' className='add-only' value='Orientation_9_6' />  Intellectual Insight
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_9_7' name='cbOrientation_9_7' className='add-only' value='Orientation_9_7' /> Impaired insight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbOrientation_9_8' name='cbOrientation_9_8' className='add-only' value='Orientation_9_8' /> Some awareness of illness/Symptoms/ Fair
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>JUDGMENT/IMPULSE CONTROL</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_1' name='cbOrientation_10_1' className='add-only' value='Orientation_10_1' /> Critical Judgment Intact
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_2' name='cbOrientation_10_2' className='add-only' value='Orientation_10_2' />  Impaired Judgment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_3' name='cbOrientation_10_3' className='add-only' value='Orientation_10_3' /> Able to Resist Impulses
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_4' name='cbOrientation_10_4' className='add-only' value='Orientation_10_4' />  Recent Impulsive Behavior
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_12' name='cbOrientation_10_12' className='add-only' value='Orientation_10_12' />  Impaired impulse Control
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_13' name='cbOrientation_10_13' className='add-only' value='Orientation_10_13' />  Compulsions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_5' name='cbOrientation_10_5' className='add-only' value='Orientation_10_5' /> Excellent
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_6' name='cbOrientation_10_6' className='add-only' value='Orientation_10_6' />  Good
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_7' name='cbOrientation_10_7' className='add-only' value='Orientation_10_7' /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_8' name='cbOrientation_10_8' className='add-only' value='Orientation_10_8' /> Fair
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_10_9' name='cbOrientation_10_9' className='add-only' value='Orientation_10_9' />  Nil
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h3>
                    MEMORY
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Remote Memory</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_11_1' name='cbOrientation_11_1' className='add-only' value='Orientation_11_1' /> Normal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_11_2' name='cbOrientation_11_2' className='add-only' value='Orientation_11_2' />  Impaired
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_11_3' name='cbOrientation_11_3' className='add-only' value='Orientation_11_3' /> Intact
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_11_4' name='cbOrientation_11_4' className='add-only' value='Orientation_11_4' />  Poor Remote
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_11_5' name='cbOrientation_11_5' className='add-only' value='Orientation_11_5' />  Poor Recent
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientation_11_6' name='cbOrientation_11_6' className='add-only' value='Orientation_11_6' />  Other:
                            &nbsp;
                            <input type='text' id='txtOrientation_11_6' name='txtOrientation_11_6' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Memory</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_12_1' name='cbOrientation_12_1' className='add-only' value='Orientation_12_1' /> Normal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_12_2' name='cbOrientation_12_2' className='add-only' value='Orientation_12_2' />  Impaired
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_12_3' name='cbOrientation_12_3' className='add-only' value='Orientation_12_3' /> Intact
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_12_4' name='cbOrientation_12_4' className='add-only' value='Orientation_12_4' />  Poor Remote
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_12_5' name='cbOrientation_12_5' className='add-only' value='Orientation_12_5' />  Poor Recent
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientation_12_6' name='cbOrientation_12_6' className='add-only' value='Orientation_12_6' />  Other:
                            &nbsp;
                            <input type='text' id='txtOrientation_12_6' name='txtOrientation_12_6' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Immediate Memory</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_13_1' name='cbOrientation_13_1' className='add-only' value='Orientation_13_1' /> Normal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_13_2' name='cbOrientation_13_2' className='add-only' value='Orientation_13_2' />  Impaired
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_13_3' name='cbOrientation_13_3' className='add-only' value='Orientation_13_3' /> Intact
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_13_4' name='cbOrientation_13_4' className='add-only' value='Orientation_13_4' />  Poor Remote
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_13_5' name='cbOrientation_13_5' className='add-only' value='Orientation_13_5' />  Poor Recent
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientation_13_6' name='cbOrientation_13_6' className='add-only' value='Orientation_13_6' />  Other:
                            &nbsp;
                            <input type='text' id='txtOrientation_13_6' name='txtOrientation_13_6' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    ATTENTION/CONCENTRATION
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Immediate Memory</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMemory_1' name='cbMemory_1' className='add-only' value='Memory_1' /> Good
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMemory_2' name='cbMemory_2' className='add-only' value='Memory_2' />  Distractible
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMemory_3' name='cbMemory_3' className='add-only' value='Memory_3' /> Variable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMemory_4' name='cbMemory_4' className='add-only' value='Memory_4' /> Not Assessed
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>THOUGHT PROCESS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_1' name='cbThought_1' className='add-only' value='Thought_1' /> Logical/Coherent
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_2' name='cbThought_2' className='add-only' value='Thought_2' />  Incomprehensible
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_3' name='cbThought_3' className='add-only' value='Thought_3' /> Incoherent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_4' name='cbThought_4' className='add-only' value='Thought_4' /> Flight of ideas
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_5' name='cbThought_5' className='add-only' value='Thought_5' />  Loose Association
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_6' name='cbThought_6' className='add-only' value='Thought_6' /> Tangential
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_7' name='cbThought_7' className='add-only' value='Thought_7' /> Circumstantial
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_8' name='cbThought_8' className='add-only' value='Thought_8' />  Rambling
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_9' name='cbThought_9' className='add-only' value='Thought_9' /> Evasive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_10' name='cbThought_10' className='add-only' value='Thought_10' /> Racing Thoughts
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_11' name='cbThought_11' className='add-only' value='Thought_11' />  Perseveration
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_12' name='cbThought_12' className='add-only' value='Thought_12' /> Thought blocking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_13' name='cbThought_13' className='add-only' value='Thought_13' /> Concrete
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_14' name='cbThought_14' className='add-only' value='Thought_14' />  Unremarkable
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>THOUGHT CONTENT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_1' name='cbThoughtContant_1' className='add-only' value='ThoughtContant_1' /> Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_2' name='cbThoughtContant_2' className='add-only' value='ThoughtContant_2' />  Consisentt with Age
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_3' name='cbThoughtContant_3' className='add-only' value='ThoughtContant_3' /> Preoccupations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_4' name='cbThoughtContant_4' className='add-only' value='ThoughtContant_4' /> Obsessions
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_5' name='cbThoughtContant_5' className='add-only' value='ThoughtContant_5' />  Compulsions
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_6' name='cbThoughtContant_6' className='add-only' value='ThoughtContant_6' /> Phobias
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_7' name='cbThoughtContant_7' className='add-only' value='ThoughtContant_7' /> Thought Broadcasting
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_8' name='cbThoughtContant_8' className='add-only' value='ThoughtContant_8' />  Thought Insertion
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_9' name='cbThoughtContant_9' className='add-only' value='ThoughtContant_9' /> Thought Withdrawal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_10' name='cbThoughtContant_10' className='add-only' value='ThoughtContant_10' /> Ideas of Reference
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContant_11' name='cbThoughtContant_11' className='add-only' value='ThoughtContant_11' />  Ideas of Influence
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbThoughtContant_12' name='cbThoughtContant_12' className='add-only' value='ThoughtContant_12' /> Other:
                            &nbsp;
                            <input type='text' id='txtThoughtContant' name='txtThoughtContant' className='add-only  w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>DELUSIONS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDelusions_1' name='cbDelusions_1' className='add-only' value='Delusions_1' /> Persecutory
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDelusions_2' name='cbDelusions_2' className='add-only' value='Delusions_2' />  Bizarre
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDelusions_3' name='cbDelusions_3' className='add-only' value='Delusions_3' /> Grandeur
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDelusions_4' name='cbDelusions_4' className='add-only' value='Delusions_4' /> Guilt
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDelusions_5' name='cbDelusions_5' className='add-only' value='Delusions_5' />  Somatic
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PERCEPTION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDelusions_6' name='cbDelusions_6' className='add-only' value='Delusions_6' /> Unremarkable/None
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>HALLUCINATIONS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHallucinations_1' name='cbHallucinations_1' className='add-only' value='Hallucinations_1' /> None
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHallucinations_2' name='cbHallucinations_2' className='add-only' value='Hallucinations_2' />  Auditory
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHallucinations_3' name='cbHallucinations_3' className='add-only' value='Hallucinations_3' /> Visual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHallucinations_4' name='cbHallucinations_4' className='add-only' value='Hallucinations_4' /> Olfactory
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHallucinations_5' name='cbHallucinations_5' className='add-only' value='Hallucinations_5' />  Tactile
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHallucinations_6' name='cbHallucinations_6' className='add-only' value='Hallucinations_6' /> Gustatory
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHallucinations_7' name='cbHallucinations_7' className='add-only' value='Hallucinations_7' /> Not Assessed
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>INTELLECTUAL FUNCTIONAL STATUS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFunctional_1' name='cbFunctional_1' className='add-only' value='Functional_1' /> Above Average
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFunctional_2' name='cbFunctional_2' className='add-only' value='Functional_2' />  Normal/Average
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFunctional_3' name='cbFunctional_3' className='add-only' value='Functional_3' /> Borderline
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>INTELLECTUAL DISABILITY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFunctional_4' name='cbFunctional_4' className='add-only' value='Functional_4' /> Mildly Impaired
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFunctional_5' name='cbFunctional_5' className='add-only' value='Functional_5' />  Moderately Impaired
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFunctional_6' name='cbFunctional_6' className='add-only' value='Functional_6' /> Severely Impaired
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFunctional_7' name='cbFunctional_7' className='add-only' value='Functional_7' /> Other:
                            &nbsp;
                            <input type='text' id='txtFunctional_7' name='txtFunctional_7' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SUICIDAL/HOMICIDAL IDEATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomicidal_1' name='cbHomicidal_1' className='add-only' value='Homicidal_1' /> Suicidal Thoughts
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomicidal_2' name='cbHomicidal_2' className='add-only' value='Homicidal_2' />  Suicidal Attempts
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomicidal_3' name='cbHomicidal_3' className='add-only' value='Homicidal_3' /> Suicidal Intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomicidal_4' name='cbHomicidal_4' className='add-only' value='Homicidal_4' /> Suicidal Plans
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomicidal_5' name='cbHomicidal_5' className='add-only' value='Homicidal_5' />  Homicidal Thoughts
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomicidal_6' name='cbHomicidal_6' className='add-only' value='Homicidal_6' /> Homicidal Attempts
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomicidal_7' name='cbHomicidal_7' className='add-only' value='Homicidal_7' /> Homicidal Intent
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomicidal_8' name='cbHomicidal_8' className='add-only' value='Homicidal_8' />  Homicidal Plans
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h3>
                    RISK ASSESSMENT
                </h3>
                <p className='w-750'>
                    Assess potential risk of harm to self or others, including patterns of risk behavior and/or risk due to personality factors, substance use, criminogenic factors, exposure of elements, exploitation, abuse, neglect, suicidal or homicidal or homicidal history, self-injury, psychosis, impulsiveness, etc.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>RISK of HARM TO SELF</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_1' name='cbHarm_1' className='add-only' value='Harm_1' /> Prior Suicide Attempt
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_2' name='cbHarm_2' className='add-only' value='Harm_2' />  Current Ideations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_31' name='cbHarm_31' className='add-only' value='Harm_3' /> Stated Plan/Intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_32' name='cbHarm_32' className='add-only' value='Harm_4' /> Suicide of friend
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_5' name='cbHarm_5' className='add-only' value='Harm_5' />  N/A
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_6' name='cbHarm_6' className='add-only' value='Harm_6' /> Marked Lack of Support
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_7' name='cbHarm_7' className='add-only' value='Harm_7' /> Recent Loss
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_8' name='cbHarm_8' className='add-only' value='Harm_8' />  Terminal Illness
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_9' name='cbHarm_9' className='add-only' value='Harm_9' /> Substance Abuse
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_10' name='cbHarm_10' className='add-only' value='Harm_10' /> Psychosis
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_11' name='cbHarm_11' className='add-only' value='Harm_11' />  Impulsivity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_12' name='cbHarm_12' className='add-only' value='Harm_12' /> Hopelessness
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_13' name='cbHarm_13' className='add-only' value='Harm_13' /> Access to means (weapons,pills)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarm_14' name='cbHarm_14' className='add-only' value='Harm_14' />  Family History of Suicide
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHarm_' name='cbHarm_' className='add-only' value='Harm_' /> Presence of Behavioral Cues (isolation, giving away possessions, rapid mood swings, etc)
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>RISK of HARM to OTHERS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmOther_1' name='cbHarmOther_1' className='add-only' value='HarmOther_1' /> N/A
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmOther_2' name='cbHarmOther_2' className='add-only' value='HarmOther_2' />  Arrests for violence
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmOther_3' name='cbHarmOther_3' className='add-only' value='HarmOther_3' /> Destruction of Property
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmOther_4' name='cbHarmOther_4' className='add-only' value='HarmOther_4' /> Substance Use
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmOther_5' name='cbHarmOther_5' className='add-only' value='HarmOther_5' />  Access to means (weapons)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmOther_6' name='cbHarmOther_6' className='add-only' value='HarmOther_6' /> Harms animals
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmOther_7' name='cbHarmOther_7' className='add-only' value='HarmOther_7' /> Angry mood/agitation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmOther_8' name='cbHarmOther_8' className='add-only' value='HarmOther_8' />  Fire setting
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmOther_9' name='cbHarmOther_9' className='add-only' value='HarmOther_9' /> Physically abused as a child
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHarmOther_10' name='cbHarmOther_10' className='add-only' value='HarmOther_10' /> Prior acts of violence; If yes, when was most recent violent act?
                            &nbsp;
                            <input type='text' id='txtHarmOther' name='txtHarmOther' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHarmOther_11' name='cbHarmOther_11' className='add-only' value='HarmOther_11' /> Psychosis/command hallucinations; If yes, is there a history of acting on any commands to harm others?
                            <br />
                            &nbsp;<input type='radio' id='rbHarm_Yes' name='rbHarm' className='add-only' value='Male' /> &nbsp;YES &nbsp;
                            <input type='radio' id='rbHarm_No' name='rbHarm' className='add-only' value='Female' /> &nbsp;NO
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>RISK of HARM to SELF or OTHERS RATING</span>
                            <span className='small'>(From LOCUS Risk of Harm Evaluation Parameters)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmSelf_1' name='cbHarmSelf_1' className='add-only' value='HarmSelf_1' /> Minimal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmSelf_2' name='cbHarmSelf_2' className='add-only' value='HarmSelf_2' />  Low
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmSelf_3' name='cbHarmSelf_3' className='add-only' value='HarmSelf_3' /> Moderate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHarmSelf_4' name='cbHarmSelf_4' className='add-only' value='HarmSelf_4' /> Serious
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHarmSelf_5' name='cbHarmSelf_5' className='add-only' value='HarmSelf_5' />  Extreme, as evidenced by:
                            &nbsp;
                            <input type='text' id='txtHarmSelf_2' name='txtHarmSelf_2' className='add-only  w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>RECIPIENT SAFETY & OTHER RISK FACTORS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSafetyRisk_1' name='cbSafetyRisk_1' className='add-only' value='SafetyRisk_1' /> Feels currently being harmed/hurt/abused/threatened by someone
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSafetyRisk_2' name='cbSafetyRisk_2' className='add-only' value='SafetyRisk_2' /> Feels unsafe in current living environment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSafetyRisk_3' name='cbSafetyRisk_3' className='add-only' value='SafetyRisk_3' />  Engages in dangerous sexual behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSafetyRisk_4' name='cbSafetyRisk_4' className='add-only' value='SafetyRisk_4' /> Relapse/Decompensation triggers
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSafetyRisk_5' name='cbSafetyRisk_5' className='add-only' value='SafetyRisk_5' /> Other:
                            &nbsp;
                            <input type='text' id='txtSafetyRisk' name='txtSafetyRisk' className='add-only  w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe recipient's preferences and desires for addressing risk factors, including any Mental Health Advance Directives or plan of response to periods of decompensation/relapse. </span><span className='small'>(Ex. Resources-recipient feels comfortable reaching out to for assistance in crisis)</span>
                    <textarea id='txtEvidencedRecipient' name='txtEvidencedRecipient' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PROTECTIVE FACTORS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProtective_1' name='cbProtective_1' className='add-only' value='Protective_1' /> Positive social support
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProtective_2' name='cbProtective_2' className='add-only' value='Protective_2' />  Cultural/religious beliefs
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProtective_3' name='cbProtective_3' className='add-only' value='Protective_3' /> Strong therapeutic rapport
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProtective_4' name='cbProtective_4' className='add-only' value='Protective_4' /> Life satisfaction
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProtective_5' name='cbProtective_5' className='add-only' value='Protective_5' />  Children in the home
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProtective_6' name='cbProtective_6' className='add-only' value='Protective_6' /> Positive coping skills
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProtective_7' name='cbProtective_7' className='add-only' value='Protective_7' /> Sufficient problem-solving skills
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProtective_8' name='cbProtective_8' className='add-only' value='Protective_8' />  Social responsibility
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h3>
                    CULTURAL and LANGUAGE PREFERENCES <span className='small'>(Language/Customs/Values/Preferences)</span>
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Spiritual Beliefs/Preferences</span>
                    <textarea id='txtSpiritualBeliefs' name='txtSpiritualBeliefs' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Cultural Beliefs/Preferences</span>
                    <textarea id='txtCulturalBeliefs' name='txtCulturalBeliefs  ' className='add-only'></textarea>
                </p>
                <h3>
                    DIAGNOSIS
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>1.Primary -</span>
                    <textarea id='txtSpiritualPrimary' name='txtSpiritualPrimary' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2.Secondary -</span>
                    <textarea id='txtSpiritualSecondary' name='txtSpiritualSecondary' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3.Tertiary -</span>
                    <textarea id='txtTertiary' name='txtTertiary' className='add-only' ></textarea>
                </p>
                <h3>
                    INTERPRETATIVE SUMMARY
                </h3>
                <p className='w-750'>
                    Describe recipient's global preferences/hopes for recovery, recommended treatments/assessments, level of care, duration. Include clinical/central theme, co-occurring disabilities, environmental and personal supports/needs.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>SUPPORTING DSM-V Criteria</span>
                    <textarea id='txtSpiritualCriteria' name='txtSpiritualCriteria' className='add-only' rows={10}></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>LOCUS SCORE:</span>
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id="txtLocusScore" name="txtLocusScore" className='add-only' />
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>IDENTIFIED NEEDS:</span>
                    <input type='text' id="txtIdentified_1" name="txtIdentified_1" className='add-only' placeholder='1.' />
                    <br/>
                    <input type='text' id="txtIdentified_2" name="txtIdentified_2" className='add-only' placeholder='2.' />
                    <br/>
                    <input type='text' id="txtIdentified_3" name="txtIdentified_3" className='add-only' placeholder='3.' />
                    <br/>
                    <input type='text' id="txtIdentified_4" name="txtIdentified_4" className='add-only' placeholder='4.' />

                </p>
                <h3>
                    RECOMMENDED SERVICES
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MH Services</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_1' name='cbServices_1' className='add-only' value='Services_1' /> CPST
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_2' name='cbServices_2' className='add-only' value='Services_2' /> PSR-Individual
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_3' name='cbServices_3' className='add-only' value='Services_3' /> PSR-Group
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_4' name='cbServices_4' className='add-only' value='Services_4' /> ACT
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_5' name='cbServices_5' className='add-only' value='Services_5' /> PSH
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_6' name='cbServices_6' className='add-only' value='Services_6' /> MED Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_7' name='cbServices_7' className='add-only' value='Services_7' /> Out Pt Therapy (Ind)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_8' name='cbServices_8' className='add-only' value='Services_8' /> Out Pt Therapy (Fam)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_9' name='cbServices_9' className='add-only' value='Services_9' /> Out Pt Therapy (Group)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SA Services</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_11' name='cbServices_11' className='add-only' value='Services_11' /> Residential TX
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_21' name='cbServices_21' className='add-only' value='Services_21' /> Halfway House
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_31' name='cbServices_31' className='add-only' value='Services_31' /> IOP
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_41' name='cbServices_41' className='add-only' value='Services_41' /> Ambulatory Detox
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_51' name='cbServices_51' className='add-only' value='Services_51' /> Out Pt Therapy (Ind)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_61' name='cbServices_61' className='add-only' value='Services_61' /> Out Pt Therapy (Fam)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServices_71' name='cbServices_71' className='add-only' value='Services_71' /> Out Pt Therapy (Group)
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h3>
                    SIGNATURE
                </h3>
                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>PRINTED NAME of ASSESSOR:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>LMHP CREDENTIALS:</span> </td> 
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id="txtPrintedName" name="txtPrintedName" className='add-only' /> </td> 
                        <td className='w-375'> <input type='text' id="txtLmhpCredentials" name="txtLmhpCredentials" className='add-only' /> </td> 
                    </tr> 
                </table>







            </div>
        </form>

    )
}